import { render, staticRenderFns } from "./SecurityCode.vue?vue&type=template&id=062d6521&"
import script from "./SecurityCode.vue?vue&type=script&lang=js&"
export * from "./SecurityCode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports